import { NgClass, NgTemplateOutlet } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatError } from '@angular/material/form-field';
import { MatRadioButton, MatRadioGroup } from '@angular/material/radio';
import { ActivatedRoute, Router } from '@angular/router';
import { ButtonActivity, ENVIRONMENT, Environment, Lead, PageActivity, Specification } from '@domains';
import { PageFooterComponent } from '@donor/components/page-footer/page-footer.component';
import {
  DesignService,
  FxFlexDirective,
  FxLayoutAlignDirective,
  FxLayoutDirective,
  FxLayoutGapDirective,
  ResponsiveService,
} from '@rspl-ui';
import { LaddaModule } from 'angular2-ladda';
import { take } from 'rxjs';

import { AppService } from '../../../../app.service';
import { CreateProgressComponent } from '../../../../components/create-progress/create-progress.component';
import { OptimizelyService } from '../../../../optimizely.service';
import { FlowService } from '../../donor-flow.service';
import { BaseFlowStepComponent } from '../base-flow-step.component';

@Component({
  selector: 'app-flow-floor',
  templateUrl: './flow-floor.component.html',
  styleUrls: ['./flow-floor.component.scss'],
  imports: [
    PageFooterComponent,
    NgTemplateOutlet,
    FxLayoutDirective,
    FxLayoutAlignDirective,
    FxFlexDirective,
    FxLayoutGapDirective,
    LaddaModule,
    CreateProgressComponent,
    NgClass,
    FormsModule,
    MatRadioButton,
    MatRadioGroup,
    MatError,
  ],
})
export class FlowFloorComponent extends BaseFlowStepComponent implements OnInit {
  staircases: number;
  staircasesStepSubmitted = false;
  willBringItemsToGroundFloor?: boolean;
  activity = ButtonActivity;
  customFloor = false;

  constructor(
    override flowService: FlowService,
    override appService: AppService,
    override router: Router,
    override route: ActivatedRoute,
    override designService: DesignService,
    override responsiveService: ResponsiveService,
    protected dialog: MatDialog,
    protected override optimizelyService: OptimizelyService,
    @Inject(ENVIRONMENT) protected override environment: Environment,
  ) {
    super(flowService, appService, router, route, designService, responsiveService, optimizelyService, environment);
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.staircases = this.flowService.lead.specification.staircases;
    this.customFloor = this.staircases > 3;
    if (this.customFloor) {
      this.staircases = this.staircases + 1; // +1 because we count the ground floor as well
    }
    this.willBringItemsToGroundFloor =
      this.flowService.lead.meta?.staircasesStepSubmitted === undefined || this.flowService.lead.meta?.staircasesStepSubmitted === null
        ? undefined
        : this.staircases === 0;
  }

  static override isCompleted(lead: Lead) {
    return lead.meta?.staircasesStepSubmitted !== null && lead.meta?.staircasesStepSubmitted !== undefined;
  }

  override isValid(): boolean {
    return (
      (Number(this.staircases) === 0 || this.willBringItemsToGroundFloor !== undefined) &&
      Number(this.staircases) >= 0 &&
      (!this.customFloor || Number(this.staircases) >= 5)
    );
  }

  override getFromValue(): Partial<Lead> {
    return {
      specification: new Specification({
        ...this.flowService.lead.specification,
        staircases: this.willBringItemsToGroundFloor ? 0 : this.customFloor ? this.staircases - 1 : this.staircases,
      }),
      meta: {
        ...this.flowService.lead.meta,
        staircasesStepSubmitted: true,
      },
    };
  }

  override showError(): void {
    this.showErrors = true;
    this.appService.createLeadActivity(this.lead?.id, ButtonActivity.DONATION_FLOOR_SUBMIT_ERROR, undefined).pipe(take(1)).subscribe();
  }

  override saveButtonActivity(): ButtonActivity {
    return ButtonActivity.DONATION_FLOOR_SUBMIT;
  }

  override pageVisitActivity(): PageActivity {
    return PageActivity.DONATION_FLOOR_PAGE;
  }

  override saveLead(): void {
    if (this.willBringItemsToGroundFloor !== undefined) {
      this.appService
        .createLeadActivity(this.leadId, ButtonActivity.STAIRCASE_POPUP_SUBMIT, { staircasesRemoved: this.willBringItemsToGroundFloor })
        .subscribe();
    }
    super.saveLead();
  }
}
